/* eslint no-underscore-dangle: "off" */
// NOTE: These will be available in the app there may be other env variables but only the ones listed below will be available in the app
const availableKeys = [
  'APP_NAME',
  'CONFIG_ENV',
  'GRAPHQL_URI',
  'BFF_URL',
  'API_GATEWAY_API_KEY',
  'PROXY_URL',
  'DATACASH_PAGE_SET_ID',
  'DATACASH_PACKAGE_PAGE_SET_ID',
  'ATB_PRINT_SERVICE',
  'PAYMENT_SERVICE_URL',
  'ADYEN_CLIENT_KEY',
  'ADYEN_ENVIRONMENT',
  'TERMINAL_MAPPER_PROXY_URL',
  'LOQATE_BASE_URL',
  'LOQATE_RETRIEVE_URL',
  'LOQATE_FIND_URL',
  'LOQATE_API_KEY',
  'ALLOWED_ISSUE_CREATORS',
  'ISSUE_CREATOR_URL',
  'ENABLE_SEARCH_DISCOUNT_BY_DATE',
  'ENABLE_VONAGE',
  'VONAGE_IFRAME_URL',
  'SENTRY_DSN',
  'SENTRY_ENVIRONMENT',
  'RELEASE',
  'ENABLE_THALYS_PASS',
  'ENABLE_EXTRAS_BOOKING_PATH',
  'ENABLE_THALYS_MULTI_JOURNEY',
  'ENABLE_HOTEL_COMPENSATION',
  'ENABLE_SHOW_SUMMATED_FARES',
  'ENABLE_SPLIT_DELAY_COMPENSATION',
  'ENABLE_ADDITIONAL_THALYS_AGENT_REFUND_METHODS',
  'ADJUSTED_POINTS_DATE',
  'ENABLE_ADVANCED_PASSENGER_INFORMATION',
  'LAUNCHDARKLY_CLIENT_ID',
  'ENABLE_THROUGH_FARES_ON_HOLD',
  'ENABLE_GENERATE_DISCOUNT_CODE',
  'ENABLE_TIER_BENEFIT_UPGRADE',
  'ENABLE_EVACUATION_CHAIR',
  'DISABLE_ADDING_EXTRAS_ON_THIRD_PARTY',
  'ENABLE_BUSINESS_ACCOUNT_BENEFIT_UPGRADE',
  'ENABLE_CANCEL_VOUCHER_CTA',
  'ENABLE_INFANTS_ON_LAP',
  'ENABLE_CLONE_EXTERNAL_TICKETS',
  'ENABLE_SNCB_UNCONFIRMED_TIMETABLE_BOOKING_EXCHANGE',
  'ENABLE_SNCB_UNCONFIRMED_TIMETABLE_MANAGE_BOOKING',
  'ENABLE_DISRUPTED_TRAINS_IN_SEARCH_RESULTS'
];

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length !== 2) {
    return null;
  }

  return parts.pop().split(';').shift();
};

const getByKey = (key, prefix, canOverride) =>
  (canOverride && getCookie(key)) ||
  (typeof window !== 'undefined' && window.__config__ && window.__config__[key]) ||
  (typeof process !== 'undefined' && process.env && (process.env[prefix + key] || process.env[key]));

const config = (key = '', options = {}) => {
  const prefix = 'REACT_APP_';

  const uppercaseKey = key.toUpperCase();

  if (uppercaseKey && uppercaseKey.startsWith(prefix)) {
    throw new Error(`Don't request config with the "${prefix}" prefix, exclude it - Use "XXX" instead of "${prefix}XXX"`);
  } else if (uppercaseKey && !availableKeys.includes(uppercaseKey)) {
    throw new Error(
      // eslint-disable-next-line max-len
      `"${uppercaseKey}" is not available to the application - If you require it in the app, add it to the key list in "src/utils/config.js"`
    );
  }

  if (uppercaseKey) {
    return getByKey(uppercaseKey, prefix, options.canOverride);
  }

  // Return all config
  return availableKeys.reduce((keys, k) => {
    const newKeys = keys;
    newKeys[k] = getByKey(k, prefix);

    return newKeys;
  }, {});
};

module.exports = config;
